module.exports = __webpack_public_path__ + "static/media/total_campaign.928daea4.svg";